import { render, staticRenderFns } from "./NoQuestion.vue?vue&type=template&id=121a4fbe&lang=pug&"
import script from "./NoQuestion.vue?vue&type=script&lang=ts&"
export * from "./NoQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports